<template>
    <v-card class="mx-auto" shaped elevation="7">
        <v-card-title>
            Proveedor Beneficio
            <v-spacer></v-spacer>
            <v-btn rounded dark color="primary" @click="dialog = true">Nuevo</v-btn>

            <modalComponent :formTitle="formTitle" :objProveedorEditar="objProveedor"
                            :listDecision="listGeneral.listDecision" :cargar="dialog"
                            :listEstados="listGeneral.listEstados" 
                            :listTipoDocumento="listGeneral.listTipoDocumento" />

        </v-card-title>
        <v-card-text>
            <v-container fluid grid-list-xl>
                <v-row dense>
                    <v-col cols="12" sm="4">
                        <v-autocomplete label="Proveedor con Beneficios *" color="textbox"
                            v-model="objSearchProveedor.beneficios" :items="listGeneral.listDecision"
                            item-value="idDecision" item-text="decision" @change="onListar" outlined dense />
                    </v-col>
                    <v-col cols="12" sm="4">
                        <v-autocomplete label="Proveedor con Servicios Complementarios *" color="textbox"
                            v-model="objSearchProveedor.servicioComplementario" :items="listGeneral.listDecision"
                            item-value="idDecision" item-text="decision" @change="onListar" outlined dense />
                    </v-col>
                    <v-col cols="12" sm="4">
                        <v-autocomplete label="Estado *" color="textbox" v-model="objSearchProveedor.estado"
                            :items="listGeneral.listEstados" item-text="nombre_estado" item-value="id_estado"
                            @change="onListar" outlined dense />
                    </v-col>
                </v-row>
                <v-row dense>
                    <v-col cols="12" sm="6"/>
                    <v-col cols="12" sm="6">
                        <v-text-field label="Buscar" color="textbox" v-model="search" clearable dense
                            prepend-inner-icon="search" />
                    </v-col>
                </v-row>
                <v-row dense>
                    <v-col cols="12">
                        <v-data-table :search="search" :headers="listGeneral.cabecera" :items="listGeneral.detalle"
                            class="elevation-3">

                            <template v-slot:item.name="{ item }">
                                <v-btn class="ma-2" text icon color="primary" @click="editarProveedor(item)">
                                    <v-icon small>edit</v-icon>
                                </v-btn>
                            </template>

                            <template v-slot:no-results>
                                Tu búsqueda de "<span v-html="search"></span>" no arrojó resultados.
                            </template>
                        </v-data-table>
                    </v-col>
                </v-row>
            </v-container>
        </v-card-text>
    </v-card>
</template>
<script>
    export default {
        name: 'ProveedorBeneficioView',
        components: {
            modalComponent:() => import('@/components/beneficio/ModalProveedorComponent.vue')
        },
        data: () => ({
            opcion:1,
            search: '',
            dialog: false,
            listGeneral: {},
            objProveedor: {},
            objSearchProveedor: {},
            editedIndex: -1,
        }),
        created() {
            axios.post(`${BASE_URI}administrador/proveedor/cargaGeneral`,{})
                .then((r) =>{
                    if(_.size(_.get(r,['data','data'],[])) == 0) throw _.get(r,['data','mensaje'],mensajeEstandar.errorPeticion);
                        this.listGeneral = r.data.data;
                        this.cargarGeneral();
                })
                .catch((e) => {
                    mensajesAlerta(e, 'E');
                });
        },
        methods: {
            cargarGeneral() {
                this.objSearchProveedor = {
                    opcion: 'L',
                    beneficios: null,
                    servicioComplementario: null,
                    estado: '1'
                };

                if (_.size(this.listGeneral.listDecision) > 0) {
                    //opcion => 1 opcion beneficios || 2 opcion servicioComplementario
                    this.objSearchProveedor.beneficios = this.opcion == 1 ? this.listGeneral.listDecision[1].idDecision : this.listGeneral.listDecision[2].idDecision;
                    this.objSearchProveedor.servicioComplementario = this.opcion == 2 ? this.listGeneral.listDecision[1].idDecision : this.listGeneral.listDecision[2].idDecision;
                }

                this.objProveedor = _.clone(this.objSearchProveedor);
                this.onListar('L');
            },
            editarProveedor(item) {
                this.editedIndex = this.listGeneral.detalle.indexOf(item)
                this.objProveedor =  _.merge({}, this.objProveedor, item);
                this.dialog = true;
            },
            onListar(event) {
                if (!_.isUndefined(event)) {
                    this.listGeneral.detalle = [];
                    var keys = ['idProveedor','beneficios','servicioComplementario','estado'];
                    var objeto = this.getValueObjet(_.cloneDeep(this.objSearchProveedor),keys);
                        objeto.opcion = 'L';

                    axios.post(`${BASE_URI}administrador/proveedor/listar`, objeto)
                         .then((r) => {
                            if (r.status != 200 || r.statusText != 'OK') throw mensajeEstandar.errorPeticion;
                            if (_.get(r,['data','existeError'],true)) throw mensajeEstandar.errorPeticion;
                            if (_.size(_.get(r,['data','data'],[])) == 0) throw _.get(r,['data','mensaje'],mensajeEstandar.errorPeticion);

                                _.forEach(r.data.data, (dato, key) => {

                                    var estadoBeneficio = (_.find(this.listGeneral.listDecision, (o) => { return _.toNumber(o.idDecision) == _.toNumber(dato['beneficios']); })).decision;
                                    var estadoSerComple = (_.find(this.listGeneral.listDecision, (o) => { return _.toNumber(o.idDecision) == _.toNumber(dato['servicioComplementario']); })).decision;

                                    this.listGeneral.detalle.push({
                                        idProveedor            : dato['idProveedor'],
                                        nombre                 : dato['nombre'],
                                        idTipoDocumento        : dato['id_tipo_documento'],
                                        tipoDocumento          : dato['tipoDocumento'],
                                        nroDocumento           : dato['nroDocumento'],
                                        direccion              : dato['direccion'],
                                        celular                : dato['celular'],
                                        telefonoPbx            : dato['telefonoPbx'],
                                        estadoBeneficio        : estadoBeneficio,
                                        beneficios             : dato['beneficios'],
                                        estadoSerComple        : estadoSerComple,
                                        servicioComplementario : dato['servicioComplementario'],
                                        estado                 : dato['estado']
                                    });
                                });

                        }).catch((e) => {
                            mensajesAlerta(e,'E');
                        });
                }
            },
            insertarActualizar(objetoModal) {
                this.objProveedor = objetoModal;
                this.objProveedor.opcion = _.isUndefined(this.objProveedor.idProveedor) ? 'I' : 'U';
                
                var keys = ['opcion','idProveedor','nombre','idTipoDocumento','nroDocumento','direccion','celular','telefonoPbx','beneficios','servicioComplementario','estado'];
                var objeto = _.merge({},_.pick(this.objProveedor,keys),{tipoDocumento: this.objProveedor.idTipoDocumento});
                

                return axios.post(`${BASE_URI}administrador/proveedor/insertOrUpdate`, objeto )
                            .then((r) => {
                                if (r.status != 200 || r.statusText != 'OK') throw mensajeEstandar.errorPeticion;
                                if (_.get(r,['data','existeError'],true)) throw mensajeEstandar.errorPeticion;
                                if (_.size(_.get(r,['data','data'],[])) == 0) throw _.get(r,['data','mensaje'],mensajeEstandar.errorPeticion);
                                    mensajesAlerta(r.data.mensaje, 'S');
                                    this.close();
                                    this.onListar('L');

                                    return r;
                            }).catch((e) => {
                                mensajesAlerta(e, 'E');
                                return e;
                            });
            },
            getValueObjet(objeto,arrayKey){
                var obj = {};
                _.forEach(arrayKey,(v) =>{
                    var val = _.isUndefined(_.get(objeto,v,0)) ? 0 : _.get(objeto,v,0);
                        _.set(obj,v,_.toNumber(val) == 0 ? null : val);
                });

                return obj;
            },
            close() {
                this.editedIndex = -1;
                this.objProveedor = {
                    opcion: 'L',
                    beneficios: null,
                    servicioComplementario: null,
                    estado: '1'
                }
                this.dialog = false
            },
        },
        computed: {
            formTitle() {
                return this.editedIndex === -1 ? 'Nuevo Proveedor' : 'Editar Proveedor'
            }
        },
        provide: function () {
            return {
                close: this.close,
                save: this.insertarActualizar
            }
        }
    }
</script>